import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar.jsx'
import PageHeader from './PageHeader.jsx'
import GlobalSearchIndicator from '../prospects/GlobalSearchIndicator.jsx'
import AnnouncementsGate from '../announcements/AnnouncementsGate.jsx'
import WorkerJobsWatcher from '../WorkerJobsWatcher.jsx'
import GmailConnectResult from '../communication/GmailConnectResult.jsx'

/** Cadre de l'espace connecté : barre latérale, en-tête de page, contenu (maquette Jean Louis V3). */
export default function DashboardLayout() {
  return (
    <div className="flex min-h-screen bg-canvas text-ink">
      <Sidebar />
      <div className="min-w-0 flex-1">
        <main className="dashboard-content mx-auto flex max-w-[1600px] flex-col gap-5 px-8 pb-24 pt-6">
          <PageHeader />
          <div className="min-w-0 border-t border-border pt-5">
            <Outlet />
          </div>
        </main>
      </div>
      <GlobalSearchIndicator />
      <AnnouncementsGate />
      <WorkerJobsWatcher />
      <GmailConnectResult />
    </div>
  )
}
